import LZUTF8 from 'lzutf8';

export function processImages(base = document) {
    const disp = (window.screen.width)<=480?'mobile':(window.screen.width)<=780?'tablet':'desktop';
    base.querySelectorAll('.wp-block-smarttouch-image figure[data-resp]').forEach((i)=>{
        const resp = JSON.parse(LZUTF8.decompress(i.dataset.resp,{inputEncoding:'Base64'}));
        i.style.setProperty('--focalx', (resp[disp]?.focalx||resp.desktop.focalx)*100+'%');
        i.style.setProperty('--focaly', (resp[disp]?.focaly||resp.desktop.focaly)*100+'%');
        i.style.setProperty('--scale', resp[disp]?.scale||resp.desktop.scale);
		i.style.setProperty('--fit', resp[disp]?.fit||resp.desktop.fit||'cover');
        let ratio = resp[disp]?.ratio||resp.desktop.ratio||'auto';
        if(ratio=='auto') {
            i.classList.add('autoratio');
        } else {
            i.classList.remove('autoratio');
		    i.style.setProperty('--ratio', ratio+'%');
        }
        const caption = document.createElement('figcaption');
        if(resp.desktop.caption) {
            caption.innerHTML = resp.desktop.caption;
            i.appendChild(caption);
        }
        if(resp.link?.action) {
            const link = document.createElement('a');
            if(['link','anchor','document'].includes(resp.link.action)) {
                link.setAttribute('href', resp.link.url);
                link.setAttribute('target', resp.link.newtab?'_blank':'_top');
            }
            if(resp.link.action=='popup') {
                link.setAttribute('onclick','popup('+resp.link.popup+');');
                link.setAttribute('data-atts', btoa(JSON.stringify(resp.link.atts)));
            }
            i.appendChild(link);
        }
        ScrollTrigger.create({
            scroller: base,
            trigger: i,
            start: 'top bottom',
            once: true,
            onEnter: () => {
                const src = resp[disp]?.url||resp.desktop.url;
                i.removeAttribute('data-resp');
                if(~src.indexOf('.svg')) {
                    fetch(src).then(res=>res.text()).then((text)=>{
                        text = text.replace(/<\?xml[^\?]*\?>/,'');
                        text = text.replace(/<!--[\s\S]*?-->\r?\n?/g,'');
                        if(resp.svg.colorMode!=='default') {
                            text = text.replace(/\#[a-f0-9A-F]{3,6}/g,'currentColor');
                            if(text.search(/currentColor/)<0) text = text.replace(/(<svg.*?>)(.*)<\/svg>/gs,'$1<g fill="currentColor">$2</g></svg>');
                        }
                        var svg = new DOMParser().parseFromString(text,'image/svg+xml').firstChild;
                        if(resp.svg.colorMode=='select') { svg.setAttribute('color', resp.svg.color); }
                        if(resp[disp].ratio=='auto') {
                            let v = svg.getAttribute('viewBox');
                            if(v) { v = v.split(' '); i.paddingBottom = ((v[3] - v[1]) / (v[2] - v[0])) * 100 + '%'; }
                        }
                        i.appendChild(svg);
                        i.classList.add('loaded');
                    });
                } else {
                    const style = getComputedStyle(i);
                    const w = Math.max(360,parseInt(style.width));
                    const h = Math.max(360,parseInt(style.height));
                    const img = document.createElement('img');
                    img.onload = () => {
                        i.appendChild(img);
                        i.classList.add('loaded');
                    }
                    if(window.themefolder) {
                        img.src = window.themefolder+'image.php?w='+w+'&h='+h+'&src='+encodeURIComponent(src);
                    } else {
                        img.src = src;
                    }
                }
            }
        })
    });
}
window.processImages = processImages;